import { render, staticRenderFns } from "./UserProfilesTable.vue?vue&type=template&id=5539be58&"
import script from "./UserProfilesTable.vue?vue&type=script&lang=ts&"
export * from "./UserProfilesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports